import { createDecimal } from './utils';
/**
 * 加法
 */
export const add = (a: number | string, b: number | string): number => {
  return createDecimal(a).plus(createDecimal(b)).toNumber();
};

/**
 * 减法
 */
export const subtract = (a: number | string, b: number | string): number => {
  return createDecimal(a).minus(createDecimal(b)).toNumber();
};

/**
 * 乘法
 */
export const multiply = (a: number | string, b: number | string): number => {
  return createDecimal(a).times(createDecimal(b)).toNumber();
};

/**
 * 除法
 */
export const divide = (a: number | string, b: number | string): number => {
  if (createDecimal(b).isZero()) {
    throw new Error('除数不能为零');
  }
  return createDecimal(a).dividedBy(createDecimal(b)).toNumber();
};
